import Vue from 'vue';
import Vuex from 'vuex';
import config from './config'
import { generateBaseStoreConfig } from '@strangeanimals/common-vue-components/src/helpers/stores';

Vue.use(Vuex);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
let persistState = (state) => ({
    user: state.user,
    apiAccessToken: state.apiAccessToken,
    isLoggedInAzure: state.isLoggedInAzure,
    serverTimezone: state.serverTimezone,
    tokenCreatedTimestamp: state.tokenCreatedTimestamp,
});

let storeConfig = generateBaseStoreConfig(config,persistState);
storeConfig.state = {
    ...storeConfig.state, ...{
        isLoadingCount: 0,
        user: null,
        error: {
            status: 200,
            message: ""
        },
        payments: [],
        pagination: {
            currentPage: 1,
            lastPage: 1,
            total: 0,
            count: 0,
            perPage: 0,
            firstItem: 1,
            lastItem: 1,
        },
        itemsPerPage: 15,
        activePage: "index",
        activePaymentID: null,
        depositList: [],
        apiAccessToken: null,
        serverTimezone: null,
        tokenCreatedTimestamp: null,
        targetLink: null,
        targetQuery: null,
        appId: null
    }
};

storeConfig.actions = {
    ...storeConfig.actions, ...{
        updatePaymentStatus(context, data) {
            context.commit("updatePaymentStatus", data);
        },
        updatePayments(context, payments) {
            context.commit("updatePayments", payments);
        },
        updatePagination(context, pagination) {
            context.commit("updatePagination", pagination);
        },
        updateActivePage(context, page) {
            context.commit("updateActivePage", page);
        },
        updateActivePaymentID(context, id) {
            context.commit("updateActivePaymentID", id);
        },
        updateDepositList(context, data) {
            context.commit("updateDepositList", data);
        },
        clearDepositList(context) {
            context.commit("clearDepositList")
        },
        updateServerTimezone(context, value) {
            context.commit("updateServerTimezone", value);
        },
        updateTokenCreatedTimestamp(context, value) {
            context.commit("updateTokenCreatedTimestamp", value);
        },
        updateTargetLink(context, value) {
            context.commit("updateTargetLink", value);
        },
        updateTargetQuery(context, value) {
            context.commit("updateTargetQuery", value);
        },
        updateAppId(context, appId) {
            context.commit("updateAppId", appId);
        },
    }
};

storeConfig.getters = {
    ...storeConfig.getters, ...{
        payments: (state) => (state.payments),
        pagination: (state) => (state.pagination),
        itemsPerPage: (state) => (state.itemsPerPage),
        activePage: (state) => (state.activePage),
        activePaymentID: (state) => (state.activePaymentID),
        depositList: (state) => (state.depositList),
        serverTimezone: (state) => (state.serverTimezone),
        isUserAdmin: (state, getters) => {
            return getters.user && (getters.user.permissions && getters.user.permissions.includes('admin'));
        },
        isUserRefundsAdmin: (state, getters) => {
            return getters.user && (getters.user.permissions && getters.user.permissions.includes('refunds-admin'));
        },
        isUserNationalManager: (state, getters) => {
            return getters.canUserAccessAllRefunds && getters.canUserAccessValidRefundsOnly && getters.canUserApproveRefunds;
        },
        canUserAccessAllRefunds: (state, getters) => {
            return getters.user && (
                getters.user.permissions
                && (getters.user.permissions.includes('access-all-refunds') || getters.user.permissions.includes('access-subordinate-refunds'))
            );
        },
        canUserAccessValidRefundsOnly: (state, getters) => {
            return getters.user && (getters.user.permissions && getters.user.permissions.includes('access-valid-refunds-only'));
        },
        canUserVerifyRefunds: (state, getters) => {
            return getters.user && (getters.user.permissions && getters.user.permissions.includes('verify-refunds'));
        },
        canUserApproveRefunds: (state, getters) => {
            return getters.user && (getters.user.permissions && getters.user.permissions.includes('approve-refunds'));
        },
        canUserAccessPayments: (state, getters) => {
            return getters.user && (getters.user.permissions
                && (
                    getters.user.permissions.includes('access-default-payments')
                    || getters.user.permissions.includes('access-masterpiece-payments')
                    || getters.user.permissions.includes('admin')
                )
            );
        },
        canUserAccessRefunds: (state, getters) => {
            return getters.user && (getters.user.permissions
                && (
                    getters.user.permissions.includes('access-own-refunds')
                    || getters.user.permissions.includes('refunds-admin')
                    || getters.user.permissions.includes('access-all-refunds')
                    || getters.user.permissions.includes('access-subordinate-refunds')
                )
            );
        },
        isUserInSalesforce: (state, getters) => {
            return !!(getters.user && getters.user.is_in_salesforce);
        },
        defaultRequestParams: (state, getters) => {
            return {
                type: 'payments',
                token: getters.builderToken,
            }
        },
        tokenCreatedTimestamp: (state) => (state.tokenCreatedTimestamp),
        targetLink: (state) => (state.targetLink),
        targetQuery: (state) => (state.targetQuery),
        canUserAccessSettings: (state, getters) => {
            return getters.isUserAdmin || getters.isUserRefundsAdmin;
        },
        appId: (state) => (state.appId),
    }
};

storeConfig.mutations = {
    ...storeConfig.mutations, ...{
        updatePaymentStatus(state, data) {
            const index = state.payments.findIndex(payment => payment.id === data.id);
            state.payments[index].paymentStatus = data.status;
        },
        updatePayments(state, payments) {
            state.payments = payments
        },
        updateDepositList(state, data) {
            if (data.add) {
                state.depositList.push(data.paymentID)
            }
            else {
                var index = state.depositList.indexOf(data.paymentID);
                if (index > -1) {
                    state.depositList.splice(index, 1);
                }
            }
        },
        updatePagination(state, pagination) {
            state.pagination = pagination
        },
        updateActivePage(state, page) {
            state.activePage = page
        },
        updateActivePaymentID(state, id) {
            state.activePaymentID = id
        },
        clearDepositList(state) {
            state.depositList = []
        },
        updateServerTimezone(state, value) {
            state.serverTimezone = value
        },
        updateTokenCreatedTimestamp(state, value) {
            state.tokenCreatedTimestamp = value
        },
        updateTargetLink(state, value) {
            state.targetLink = value
        },
        updateTargetQuery(state, value) {
            state.targetQuery = value
        },
        updateAppId(state, value) {
            state.appId = value
        },
    }
};

export default () => new Vuex.Store(storeConfig);
